// HTTP errors must reject the request so the UI does not report false success.
// A rejection from this API must not clear the user's session for the whole site.
export async function checkToken(response, format = 'json') {
    const text = await response.text();
    let result = text;
    if (text.trim()) {
        try { result = JSON.parse(text); } catch { /* Some successful mutations return text. */ }
    }
    let message;
    if (response.status === 401) message = 'Для просмотра вакансий войдите в аккаунт. Если вы уже вошли, авторизуйтесь повторно.';
    else if (response.status === 403) message = 'У вашего аккаунта нет доступа к этому запросу.';
    else if (response.status === 413) message = 'Сервер не принял размер резюме. Выберите файл меньшего размера.';
    else if (!response.ok || result?.error || result?.success === false || text === 'Unauthorized role' || text === 'invalid token') {
        message = typeof result?.error === 'string' ? result.error : 'Не удалось выполнить запрос. Попробуйте позже.';
    }
    if (message) {
        const error = new Error(message);
        error.status = response.status;
        throw error;
    }
    return format === 'text' ? text : result;
}
